import { render, staticRenderFns } from "./Managelicenses.vue?vue&type=template&id=4bcfca0f&"
import script from "./Managelicenses.vue?vue&type=script&lang=js&"
export * from "./Managelicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports